const c = {
  name: "FormulaLaunchFast",
  dimensions: { width: 32, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 32 40" style="enable-background:new 0 0 32 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M13,23c0-1.7,1.3-3,3-3c1.7,0,3,1.3,3,3c0,1.7-1.3,3-3,3C14.3,26,13,24.7,13,23z M16,22c-0.6,0-1,0.4-1,1
			s0.4,1,1,1s1-0.4,1-1S16.6,22,16,22z"/>
		<path class="st0" d="M16,0c-1.7,0-3,1.3-3,3c0,0.5,0.1,0.9,0.3,1.3l-9,9C3.9,13.1,3.5,13,3,13c-1.7,0-3,1.3-3,3h2c0-0.5,0.5-1,1-1
			c0.5,0,1,0.5,1,1c0,0.5-0.5,1-1,1v2c1.7,0,3-1.3,3-3c0-0.5-0.1-0.9-0.3-1.3l9-9C15.1,5.9,15.5,6,16,6c0.5,0,0.9-0.1,1.3-0.3l9,9
			C26.1,15.1,26,15.5,26,16c0,0.5,0.1,0.9,0.3,1.3L22,21.6v-3.9L17,9h-2l-5,8.7v9.9l-4,4V40h3.4l2-2H15v2h2v-2h3.6l2,2H26v-8.4l-4-4
			v-3.1l5.7-5.7c0.4,0.2,0.8,0.3,1.3,0.3c1.7,0,3-1.3,3-3c0-1.7-1.3-3-3-3c-0.5,0-0.9,0.1-1.3,0.3l-9-9C18.9,3.9,19,3.5,19,3
			C19,1.3,17.7,0,16,0z M15,3c0-0.6,0.4-1,1-1s1,0.4,1,1c0,0.6-0.4,1-1,1S15,3.6,15,3z M12,36V19h8v17h-3v-9h-2v9H12z M19.2,17h-6.5
			l3.3-5.7L19.2,17z M8,32.4l2-2v6.2L8.6,38H8V32.4z M28,16c0-0.6,0.4-1,1-1s1,0.4,1,1s-0.4,1-1,1S28,16.6,28,16z M22,36.6v-6.2l2,2
			V38h-0.6L22,36.6z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as FormulaLaunchFast
};
